<template>
  <div :id="`wrapper-${inputIdMonth}`">
    <input
      :id="inputIdMonth"
      v-model="month"
      v-regexp="/^\d+$/"
      type="tel"
      :class="['ym-disable-keys', $v.$error && 'invalid']"
      :title="$t('enter.date.month')"
      placeholder="00"
      autocomplete="cc-exp-month"
      data-private
      @focus="checkReset"
      @input="onMonth"
      @blur="checkLength"
      @keyup.delete="onMonthDelete"
    />

    <span>/</span>

    <input class="ym-disable-keys"
      :id="inputIdYear"
      v-model="year"
      v-regexp="/^\d+$/"
      v-maxLengthForDateAutocomplete
      type="tel"
      :title="$t('enter.date.year')"
      placeholder="00"
      autocomplete="cc-exp-year"
      data-private
      @focus="checkReset"
      @input="onYear"
      @blur="checkLength"
      @keyup.delete="onYearDelete"
    />

    <label :for="inputIdYear">
      {{ $t('enter.card.date') }}
    </label>
  </div>
</template>

<script>
import { required, between } from 'vuelidate/lib/validators';

let _canPrevYear = true;

const currentYear = parseInt(new Date().getFullYear().toString().substr(-2));

export default {
  props: {
    inputIdYear: String,
    inputIdMonth: String,
  },
  data() {
    return {
      month: '',
      year: '',
      isMonth: false,
      isYear: false,
    };
  },
  validations() {
    return {
      month: {
        required,
        between: between(1, 12),
      },
      year: {
        required,
        between: between(currentYear - 10, currentYear + 10),
      },
    };
  },
  methods: {
    // eslint-disable-next-line complexity
    onMonth() {
      if (!/[0-9]/.test(this.month)) {
        this.month = this.month.slice(0, -1);
      }

      if (this.month.length === 1 && !/[0-1]/.test(this.month)) {
        this.month = '0' + this.month;
        this.isMonth = true;
      } else if (this.month.length >= 2 && !this.$v.month.between) {
        if (this.month.length > 2) {
          this.month = this.month.slice(0, -1);
        } else {
          this.month = '12';
        }
        this.isMonth = true;
      } else if (this.month.length === 2 && this.$v.month.between) {
        this.isMonth = true;
      }

      if (this.month.length === 2 && this.isMonth) {
        this.$emit('focusNext');
        this.$emit('onMonth', this.month);
      }
    },
    onYear(e) {
      _canPrevYear = undefined;

      if (this.year.length >= 2 && !this.$v.year.between) {
        this.$v.$touch();
        this.isYear = false;
      } else {
        this.isYear = true;
      }

      if (this.year.length === 2 && this.isYear) {
        // if (!this.$v.year.afterCurrentDate) {
        //   this.$v.$touch();
        //   this.isMonth = false;
        // } else {
        //   this.$emit('focusNext');
        //   this.$emit('onYear', this.year);
        // }
        this.$emit('focusNext');
        this.$emit('onYear', this.year);
      }
    },
    onMonthDelete() {
      this.checkReset();
      this.$emit('onMonth', false);
    },
    onYearDelete() {
      this.checkReset();
      this.$emit('onYear', false);

      if (_canPrevYear) {
        this.$emit('focusPrev');
      }

      _canPrevYear = this.year ? undefined : true;
    },
    checkLength() {
      if (this.month.length !== 2 || this.year.length !== 2) {
        this.$v.$touch();
      }
    },
    checkReset() {
      this.$v.$reset();
    },
  },
};
</script>
